<template>
  <div>
    <bar-chart
      :chart-data="chartData"
      :title="$t('smi_sri.individual_toefl')"
      :ticks-config="ticksConfig"
    ></bar-chart>
  </div>
</template>

<script>
import BarChart from "@/components/Base/BarChart";
import { COLOR_CHART_TOEFL } from "@/helpers/color-chart-config";
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  components: {
    BarChart
  },
  props: ["dataDetail"],
  data() {
    return {
      chartData: {},
      ticksConfig: {
        yAxes: {
          max: 120
        }
      }
    };
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      const testDate = this.dataDetail.toefl
        .map(item => convertDateFromServer(item.test_date, "date"))
        .reverse();
      const testName = this.dataDetail.toefl.map(item => item.test_name);

      const prefixTooltips = [];
      testDate.map((date, index) => {
        prefixTooltips.push(`${testName[index]} (${testDate[index]})`);
      });

      const datasetsChart = [];
      this.dataDetail.data_chart.map(item => {
        datasetsChart.push({
          ...item,
          backgroundColor: COLOR_CHART_TOEFL[item.label]
        });
      });

      this.chartData = {
        labels: testDate,
        datasets: datasetsChart,
        prefix: prefixTooltips,
        isTotal: true,
        percentageData: false
      };
    }
  }
};
</script>
